import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "w-full max-w-xl p-8 flex flex-col space-y-4" }
const _hoisted_2 = { class: "flex flex-row items-start space-x-2 mb-3" }
const _hoisted_3 = { class: "flex" }
const _hoisted_4 = { class: "font-semibold text-gray-900 self-center" }
const _hoisted_5 = { class: "space-y-6" }
const _hoisted_6 = { class: "flex flex-row space-x-6" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "px-5 border-l-2 text-xl border-gray-200" }, " % ", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "px-5 border-l-2 text-xl border-gray-200" }, " % ", -1)
const _hoisted_9 = { class: "flex flex-row space-x-8" }
const _hoisted_10 = { class: "px-5 border-l-2 text-xl border-gray-200" }
const _hoisted_11 = {
  key: 0,
  class: "flex flex-row space-x-8"
}
const _hoisted_12 = { class: "flex flex-col space-y-2" }
const _hoisted_13 = {
  key: 0,
  class: "pt-1 mt-1 text-sm text-gray-600 leading-4 border-t border-transparent"
}
const _hoisted_14 = { class: "w-full justify-start flex flex-col space-y-4" }
const _hoisted_15 = { class: "flex flex-end justify-end space-x-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseIcon = _resolveComponent("BaseIcon")!
  const _component_BaseNumberInput = _resolveComponent("BaseNumberInput")!
  const _component_BaseSelect = _resolveComponent("BaseSelect")!
  const _component_RadioGroup = _resolveComponent("RadioGroup")!
  const _component_BaseButton = _resolveComponent("BaseButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_BaseIcon, {
          name: "lungs",
          stroke: false,
          height: "2rem"
        })
      ]),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('custom.uhb.copd.patient-settings')), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_BaseNumberInput, {
          "model-value": _ctx.settings.spo2_range_low?.toString() || '',
          "data-dusk": "edit-patient-settings-spo2-range-low-input",
          class: "flex w-1/2",
          step: "any",
          "show-button": false,
          label: _ctx.$t('custom.uhb.copd.spo2-target-range'),
          placeholder: "Min",
          error: 
            _ctx.validationErrors &&
              _ctx.validationErrors['settings.spo2_range_low'] &&
              _ctx.validationErrors['settings.spo2_range_low'][0]
          ,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.updateSettings({ spo2_range_low: $event })))
        }, {
          "use-default": _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        }, 8, ["model-value", "label", "error"]),
        _createElementVNode("div", {
          class: _normalizeClass(["flex self-end w-1/2", [_ctx.validationErrors &&
            _ctx.validationErrors['settings.spo2_range_high'] &&
            _ctx.validationErrors['settings.spo2_range_high'][0] && 'mt-8']])
        }, [
          _createVNode(_component_BaseNumberInput, {
            "model-value": _ctx.settings.spo2_range_high?.toString() || '',
            "data-dusk": "edit-patient-settings-spo2-range-high-input",
            "show-button": false,
            step: "any",
            placeholder: "Max",
            error: 
              _ctx.validationErrors &&
                _ctx.validationErrors['settings.spo2_range_high'] &&
                _ctx.validationErrors['settings.spo2_range_high'][0]
            ,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.updateSettings({ spo2_range_high: $event })))
          }, {
            "use-default": _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          }, 8, ["model-value", "error"])
        ], 2)
      ]),
      _createElementVNode("div", _hoisted_9, [
        (_ctx.oxygenTypes.items.length)
          ? (_openBlock(), _createBlock(_component_BaseSelect, {
              key: 0,
              "data-dusk": "edit-patient-settings-method-of-oxygen-delivery",
              class: _normalizeClass(_ctx.showFlowRate ? 'w-1/2' : 'w-full'),
              "model-value": _ctx.oxygenValue,
              label: _ctx.$t('custom.uhb.copd.inspired-oxygen'),
              placeholder: _ctx.$t('platform.common.select-option'),
              options: _ctx.oxygenTypes.toOptions(),
              error: 
            _ctx.validationErrors &&
              _ctx.validationErrors['settings.method_of_oxygen_delivery'] &&
              _ctx.validationErrors['settings.method_of_oxygen_delivery'][0]
          ,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.onOxygenTypeChange($event) && _ctx.clearError('settings.method_of_oxygen_delivery')))
            }, null, 8, ["class", "model-value", "label", "placeholder", "options", "error"]))
          : _createCommentVNode("", true),
        (_ctx.showFlowRate)
          ? (_openBlock(), _createBlock(_component_BaseNumberInput, {
              key: 1,
              "model-value": _ctx.settings.flow_rate ? _ctx.settings.flow_rate.toString() : '',
              class: "w-1/2",
              step: "any",
              min: "0",
              max: "15",
              "show-button": false,
              label: _ctx.$t('custom.uhb.copd.flow-rate'),
              error: 
            _ctx.validationErrors && _ctx.validationErrors['settings.flow_rate'] && _ctx.validationErrors['settings.flow_rate'][0]
          ,
              "data-dusk": "edit-patient-settings-flow-rate",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.updateSettings({ flow_rate: $event })))
            }, {
              "use-default": _withCtx(() => [
                _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('custom.uhb.copd.litres-per-min')), 1)
              ]),
              _: 1
            }, 8, ["model-value", "label", "error"]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.tagsFeatureFlag)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_RadioGroup, {
                label: _ctx.$t('custom.uhb.copd.is-the-patient-home-monitoring'),
                options: _ctx.homeMonitoringValues,
                "model-value": _ctx.selectedHomeMonitoringOption,
                error: _ctx.homeMonitoringValidationError,
                "label-position": "left",
                "data-dusk": "home-monitoring-options",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.updateHomeMonitoringOption($event)))
              }, null, 8, ["label", "options", "model-value", "error"]),
              (!_ctx.homeMonitoringValidationError)
                ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.$t('custom.uhb.copd.where-patient-will-record-at-home')), 1))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _createVNode(_component_BaseButton, {
          class: "mt-8",
          size: "large",
          color: "ghost",
          onClick: _ctx.closePatientSettingsModal
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('platform.common.cancel')), 1)
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_BaseButton, {
          class: "mt-8",
          size: "large",
          color: "primary",
          onClick: _ctx.updatePatientSettings
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('platform.common.update')), 1)
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ])
  ]))
}